import React, { Component } from "react";
import { compose } from "recompose";
import { translate } from "react-i18next";
import { withRouter } from "react-router-dom";
import axios from "axios";
// import { Link } from 'react-router-dom';

let cancelToken;
let state;
let tokenSession;

class Benefit extends Component {
  getInitState = () => {
    return {
      benefit: [],
    };
  };

  constructor(props) {
    super(props);
    if (tokenSession !== props.getTokenSession()) {
      state = this.getInitState();
    }
    this.state = state;
  }

  componentWillMount() {
    cancelToken = axios.CancelToken.source();
  }

  componentDidMount() {
    this.reload();
  }

  componentWillUnmount() {
    cancelToken.cancel("Component will unmount.");
    state = this.state;
    tokenSession = this.props.getTokenSession();
  }

  reload = () => {
    this.getBenefit({
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession(),
      benefit_id: this.props.match.params.benefitid,
    });
  };

  getBenefit = (params) => {
    this.props.post(
      "/getBenefit",
      params,
      (response) => this.didGetBenefit(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  };

  didGetBenefit = (response) => {
    this.setState({ benefit: response });
  };

  handleErrorResponse = (error) => {
    alert(error);
  };

  render() {
    const { t } = this.props;
    const benefit = this.state.benefit;
    return (
      <div className="content-benefits">
        <div className="container-benefit-title">
          <div className="row">
            <div className="col-md-12">
              <h2 className="page-header">{t("guest.benefits.heading")}</h2>
            </div>
          </div>
        </div>
        <div className="container-benefit">
          <div className="container-room-header card-panel panel panel-default card">
            <div
              className="panel-heading card-panel-heading"
              style={{ backgroundImage: "url('" + benefit.logo + "')" }}
            ></div>
            <div className="card-panel-body">
              <div className="panel-body-title">
                <h4 className="ioscentro">{benefit.name}</h4>
                <h4 className="iossala">
                  {benefit.group_name === "Tarifa Preferencial"
                    ? benefit.group_name
                    : benefit.discount + "% de descuento"}
                </h4>
                {benefit.codigo_descuento && (
                  <h4 className="iossala">
                    Código: {benefit.codigo_descuento}
                  </h4>
                )}
              </div>
              <div className="panel-body-description">
                <button
                  className={
                    "btn btn-block btn-singup btn_benefit " + benefit.group_name
                  }
                  type="button"
                >
                  {benefit.group_name}
                </button>
                <a
                  href={benefit.website ? benefit.website : " "}
                  target="_blank"
                >
                  <button
                    className="btn btn-block btn-primary btn-singup btn_benefit"
                    type="button"
                  >
                    {t("guest.benefits.btn_link_benefit")}
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
        <article className="container-room-description grid-2">
          <section>
            <h4 className="page-header text-primary">
              <strong>{t("guest.benefits.heading_about")}</strong>
            </h4>
            <p className="panel-description-text">{benefit.description}</p>
          </section>
          <section>
            <h4 className="page-header text-primary">
              <strong>{t("guest.benefits.discount_terms")}</strong>
            </h4>
            <p className="panel-description-text">{benefit.discount_terms}</p>
          </section>
        </article>
        <div className="container-room-direction">
          <h4 className="page-header text-primary">
            <strong>
              {t("guest.benefits.LearnMore")} {benefit.name}
            </strong>
          </h4>
          <div className="grid-2">
            <div className="text">
              <h4 className="text-primary text-center">
                <strong>{t("guest.benefits.sucursales")}</strong>
              </h4>
              {(benefit.branch_offices != null) && (benefit.branch_offices.length) ? (
                <ListOfAddresses addresses={benefit.branch_offices} />
              ) : (
              <p>
                {benefit.direccion
                  ? benefit.direccion.split(",").map((row, index) => (
                      <span key={index} style={{ textTransform: "capitalize" }}>
                        <br />
                        {row.toLowerCase()}
                      </span>
                    ))
                  : "No hay dirección registrada"}
              </p>
              )}
            </div>
            <div className="mapa">
              {benefit.gallery ? (
                <div
                  id="carousel-example-generic"
                  className="carousel slide"
                  data-ride="carousel"
                >
                  <div className="carousel-inner" role="listbox">
                    <div className="item active">
                      <img src={benefit.logo} alt="{benefit.logo}" />
                    </div>
                    {benefit.gallery.map((picture, index) => (
                      <div key={index} className="item">
                        <img src={picture} alt="{benefit.logo}" />
                      </div>
                    ))}
                  </div>
                  <a
                    className="left carousel-control"
                    href="#carousel-example-generic"
                    role="button"
                    data-slide="prev"
                  >
                    <span
                      className="glyphicon glyphicon-chevron-left"
                      aria-hidden="true"
                    ></span>
                    <span className="sr-only">Previous</span>
                  </a>
                  <a
                    className="right carousel-control"
                    href="#carousel-example-generic"
                    role="button"
                    data-slide="next"
                  >
                    <span
                      className="glyphicon glyphicon-chevron-right"
                      aria-hidden="true"
                    ></span>
                    <span className="sr-only">Next</span>
                  </a>
                </div>
              ) : null}
            </div>
          </div>
        </div>
        <strong>
          *{t("guest.benefits.Contact")} {benefit.name}{" "}
          {t("guest.benefits.Contact2")}
        </strong>
      </div>
    );
  }
}

const ListOfAddresses = ({ addresses }) => (
  <ul>
    {addresses.map(({address}, index) => (
      <li key={index}>{address}</li>
    ))}
  </ul>
);

export default compose(translate("common"), withRouter)(Benefit);



// WEBPACK FOOTER //
// ./src/dashboard/benefits/Benefit.js